import React, { useEffect, useState } from 'react';

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { analytics } from '@features/analytics';
import Cookies from 'js-cookie';

type FeatureFlagProviderProps = {
  children: React.ReactNode;
  clientKey: string;
  siteSlug: string;
};

export function FeatureFlagProvider({ children, clientKey, siteSlug }: FeatureFlagProviderProps) {
  const [gb] = useState(() => {
    return new GrowthBook({
      apiHost: 'https://growthbook-proxy.control.onejourney.travel',
      clientKey,
      attributes: { id: Cookies.get('gbuuid'), siteSlug },
      trackingCallback: (experiment, result) => {
        analytics.track({
          event: 'experiment_viewed',
          params: {
            experiment_id: experiment.key,
            variation_id: result.variationId,
            site_slug: siteSlug,
          },
        });
      },
    });
  });

  const [ready, setReady] = useState(false);

  useEffect(() => {
    gb.init({ streaming: false, timeout: 2000 })
      .then(() => setReady(true))
      .catch(() => setReady(true));
  }, [gb]);

  if (!ready) return null;

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
}
